import axios from 'axios'

export type ProductLifecycleStatus = 'active' | 'discontinued' | 'not_used'

export interface SellerProductSupplier {
  supplier_id: number
  fornecedor: string
}

export interface SellerProductCnpj {
  cnpj: string
  current_stock: number
  total_entries: number
  total_sales: number
  first_imported_at: string
  last_imported_at: string
  lifecycle_status: ProductLifecycleStatus
  status_note: string
  status_updated_at?: string | null
  has_override: boolean
}

export interface SellerManagedProduct {
  ean: string
  product_name: string
  description: string
  industry: string
  foto: string
  suppliers: SellerProductSupplier[]
  cnpjs: SellerProductCnpj[]
  cnpj_count: number
  current_stock: number
  total_entries: number
  total_sales: number
  first_imported_at: string
  last_imported_at: string
  lifecycle_status: ProductLifecycleStatus
  status_note: string
  status_updated_at?: string | null
  has_cnpj_overrides: boolean
  is_mixed_status: boolean
}

export interface SellerProductSummary {
  total: number
  active: number
  discontinued: number
  not_used: number
}

interface Envelope<T> {
  success: boolean
  data: T
  error?: string
}

function dataOrThrow<T>(response: {data: Envelope<T>}): T {
  if (!response.data.success) {
    throw new Error(response.data.error || 'N\u00e3o foi poss\u00edvel concluir a opera\u00e7\u00e3o.')
  }
  return response.data.data
}

export async function getSellerProducts(): Promise<{
  products: SellerManagedProduct[]
  summary: SellerProductSummary
}> {
  return dataOrThrow(
    await axios.get<Envelope<{products: SellerManagedProduct[]; summary: SellerProductSummary}>>(
      '/sellers/stock-intelligence/products'
    )
  )
}

export async function updateSellerProductStatus(
  ean: string,
  lifecycleStatus: ProductLifecycleStatus,
  statusNote: string,
  cnpj: string = '*'
): Promise<SellerManagedProduct> {
  const normalizedEan = String(ean ?? '').replace(/\.0$/, '').trim()

  return dataOrThrow(
    await axios.put<Envelope<SellerManagedProduct>>(
      `/sellers/stock-intelligence/products/${encodeURIComponent(normalizedEan)}/status`,
      {
        ean: normalizedEan,
        lifecycle_status: lifecycleStatus,
        status_note: statusNote,
        cnpj,
      }
    )
  )
}
